import React, {Component} from "react";

class RoomCardTimer extends Component {
    constructor(props) {
        super(props);

        var timeLeft = props.timer + Math.round(Math.random() * 15);
        this.state = {
            timeLeft: timeLeft
        };
    }

    componentDidMount() {
        setInterval(this.timerTick.bind(this), 1000);
    }

    timerTick() {
        var {timeLeft} = this.state;

        timeLeft--;

        if (timeLeft <= 0) {
            timeLeft = this.props.timer;
        }

        this.setState({timeLeft: timeLeft});
    }

    prepareTimer() {
        var {timeLeft} = this.state;

        // if (timeLeft < 60) {
        //     return timeLeft;
        // }
        
        if (timeLeft < 0 || isNaN(timeLeft)) {
            timeLeft = 0;
        }

        return new Date(timeLeft * 1000).toISOString().substr(14, 5);

    }

    render() {
        return (
        <span className='room_card_timer'>{this.prepareTimer()}</span>
        )
    }
}

export default RoomCardTimer;


// WEBPACK FOOTER //
// ./src/components/containers/online-room-list/room_card_timer.js